import { render } from "./CourseMaterialsManager.vue?vue&type=template&id=0614eb4b&scoped=true"
import script from "./CourseMaterialsManager.vue?vue&type=script&lang=js"
export * from "./CourseMaterialsManager.vue?vue&type=script&lang=js"

import "./CourseMaterialsManager.vue?vue&type=style&index=0&id=0614eb4b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0614eb4b"]])

export default __exports__